<template lang="pug">
    div

        modal-supervisor(
            :available="showModal" 
            title="NOTA DE CRÉDITO"  
            @check-key="auth()"
            confirmMessage="Autorizar reimpresión de documento"
            style="opacity: 0; position: fixed; top:0px; left:0px; margin-left: -1000px;"
            @closed="$router.push('/')"
        )
        v-container.pt-1(grid-list-md='' text-xs-left='')
            v-card(tile='')
                v-toolbar(card='' dark='' flat='' :color='colors.info' height='60')
                    v-toolbar-title Nota de crédito
                        v-icon web
                    v-spacer
            v-card
                v-toolbar(card='' dark='' :color='colors.infoSub' height='40')
                    v-icon search
                    v-toolbar-title Buscar Documento Electrónico
                v-card-text
                    v-form(ref='form_buscar_folio' v-model='validate' lazy-validation='')
                        v-layout.pt-2(row='' wrap='')
                            v-flex(md3)
                                //- v-progress-circular(indeterminate='' :color='colors.info' v-show="loading" )
                                v-select.pl-5.pr-3(
                                    :items='arrTipoDocumento'
                                    item-value='id'
                                    item-text='nombre'
                                    v-model='posSaleTypeId' 
                                    label='Tipo Documento' 
                                    :rules="[v => !!v || 'Codigo Referencia es requerido']"
                                    prepend-icon='recent_actors' 
                                    required='required'
                                    v-show='arrTipoDocumento'
                                    ref="selectDocType"
                                )
                            v-flex(md4='')
                                v-menu(content-class='ml-4 white' bottom offset-y)
                                    template( slot='activator' )
                                        v-text-field.pl-5(
                                            :label="posSaleTypeId === 3 ? 'N° Ticket' : 'N° Folio'" 
                                            prepend-icon='priority_high' 
                                            :rules='[rules.folioValido]'
                                            v-model='numeroFolio'   
                                            required='required' 
                                            maxlength='20' 
                                            ref="numFolio"
                                            @keydown.enter="searchSale()"
                                            @keyup='searchSuggest'
                                            mask="####################"
                                        )
                                    v-progress-linear.ma-0( indeterminate v-if='searching' )
                                    template( v-for='suggest in suggests' )
                                        v-btn(flat :disabled='searching' block @click='setNumeroFolio(suggest)') {{ suggest }}
                                    template( v-if='suggests.length < 1')
                                        v-btn(flat block disabled) sin sugerencias
                            v-flex.ml-4(
                                md1
                                )
                                v-checkbox(
                                    label="TBK" v-model="tbkSearch"
                                    v-if="posSaleTypeId !== 3"
                                    )
                            //- TODO: Revisar si esto quedó bien merge hotfix -> develop
                            //- v-flex.ml-4(md1)
                                v-checkbox(label="TBK" :disabled='posSaleTypeId==2' v-model="tbkSearch")
                            v-flex(md2='' align-self-start='')
                                //- v-progress-circular(indeterminate='' :color='colors.primary' v-show='folioValido')
                                v-btn(
                                    fab='' 
                                    dark=''  
                                    :color='colors.info' 
                                    
                                    v-on:click='searchSale()'
                                    )
                                    v-icon(dark='') search
            v-card(v-if="infoSale")
                v-toolbar(card='' dark='' :color='colors.infoSub' height='40')
                    v-toolbar-title Información venta
                v-layout.pa-2(row wrap)
                    v-flex(md3 v-if="infoSale.dteTypeInvoice")
                        v-icon assignment_late
                        | RUT:
                    v-flex.informationSummaries(md3 v-if="infoSale.dteTypeInvoice") {{infoSale.sl_customer.rut}}
                    v-flex(md3 v-if="infoSale.dteTypeInvoice")
                        v-icon person
                        | CLIENTE:
                    v-flex.informationSummaries(md3 v-if="infoSale.dteTypeInvoice") {{infoSale.sl_customer.business_name}}
                    v-flex(md3)
                        v-icon send
                        | FOLIO:
                    v-flex.informationSummaries(md3) {{infoSale.number}}

                    v-flex(md3 v-if="infoSale.dteTypeInvoice")
                        v-icon attach_money
                        | NETO:
                    v-flex.informationSummaries(md3 v-if="infoSale.dteTypeInvoice") {{infoSale.netTotal | mixFormatCurrency}}
                    v-flex(md3)
                        v-icon watch_later
                        | FECHA EMISIÓN:
                    v-flex.informationSummaries(md3) {{infoSale.emissionDate}}
                    //- v-flex(md3)
                    //-     v-icon attach_money
                    //-     | DESCUENTO %:
                    //- v-flex.informationSummaries(md9) {{infoSale.globalDiscountPercentage}}
                    //- v-flex(md3)
                    //-     v-icon attach_money
                    //-     | MONTO DESCONTADO:
                    //- v-flex.informationSummaries(md9) {{infoSale.globalDiscountAmount}}
                    
                    v-flex(md3 v-if="infoSale.dteTypeInvoice")
                        v-icon attach_money
                        | IVA:
                    v-flex.informationSummaries(md3 v-if="infoSale.dteTypeInvoice") {{infoSale.iva | mixFormatCurrency}}
                    v-flex(md3)
                        v-icon watch_later
                        | DTE:
                    v-flex.informationSummaries(md3 v-if="infoSale.dteTypeInvoice") {{typeDte(infoSale.dteTypeInvoice)}}
                    v-flex.informationSummaries(md3 v-if="infoSale.dteTypeTicket") {{typeDte(infoSale.dteTypeTicket)}}
                    v-flex.informationSummaries(md3 v-if="infoSale.type") {{infoSale.type}}
                    v-flex(md3)
                        v-icon attach_money
                        | TOTAL:
                    v-flex.informationSummaries(md3) {{infoSale.total | mixFormatCurrency}}
                    v-flex.xs12.mt-3(v-if="!infoSale.type")
                        v-form(ref="form2")
                            v-layout
                                v-flex.xs12.md6
                                    v-text-field(
                                        outline
                                        label="N°Nota de Crédito"
                                        v-model="creditNoteNumber"
                                        :rules="[mixRules.required]"
                                        mask="###########"
                                        v-if="integrationCountersAreEnabled"
                                        )
                                    v-switch( 
                                        color='teal' 
                                        hide-details 
                                        :disabled='!see_flag_cash_return'
                                        label='Entregar vuelto'
                                        v-model='flag_cash_return' 
                                        )
                                    v-switch(
                                        color='teal'
                                        label='Se anuló el pago con crédito de la máquina transbank'
                                        v-if='canFlagWithTransbankCreditCancellation'
                                        v-model='flagWithTransbankCreditCancellation'
                                        )
                                v-flex.xs12.md6
                                    v-textarea(
                                        outline
                                        no-resize
                                        label="Comentario"
                                        v-model="comment"
                                        )
                    v-flex.xs-12.mt-3

            v-card(v-if="infoSale")
                v-layout.pa-2(row wrap)
                    v-flex(md12)
                        v-btn(
                            round='' 
                            block='' 
                            :color='colors.info' 
                            dark='' 
                            :disabled="loading"
                            v-on:click='sendNotaCredito()'
                            ) {{infoSale.type ? 'Anular Venta' : 'Generar Nota de Crédito'}}
                            //- round=''
                            //- block=''
                            //- :color='colors.info'
                            //- dark=''
                            //- v-on:click='sendNotaCredito()'
                            //- :disabled="loading"
                            //- ) Generar Nota de Crédito


</template>

<script>
import creditNoteService from '@/services/API/creditNote/creditNoteService'
import {
    arrayToFrontEndFormat,
    objectToBackendFormat,
    objectToFrontEndFormat,
} from '@/services/ObjectFormatter'
import { dteSaleFormat } from '@/services/API/creditNote/formatData'
import { getIntegrationCreditNoteNumber } from '../../services/API/Integration'
import { mapActions, mapGetters, mapState } from 'vuex'
import DateUtils from '@/mixins/DateStrings.js'
import CurrencyUtils from '@/mixins/reusable_mixins/CurrencyUtils'
import InputValidations from '@/mixins/InputValidations'
import ModalSupervisor from '@/components/SupervisorUniqueKey/Modal'
//services
import getNumberTicket from '../../services/API/creditNote/getNumberTicket'
//
import PosSaleModel from '@/models/POS/PosSale' //pos_customer_receivable_payment_id
import PosCustomerReceivablePaymentModel from '@/models/POS/PosCustomerReceivablePayment' //pos_customer_receivable_payment_id
//
import SaleTicketModel from '@/models/Sale/SlSaleTicket'
import SaleInvoiceModel from '@/models/Sale/SlSaleInvoice'
import PosEmployeeSale from '../../models/POS/PosEmployeeSale'
import SlSaleCreditNote from '../../models/Sale/SlSaleCreditNote'
// import Axios from 'axios'
//
export default {
    name: 'credit-note',
    props: {},
    data: function() {
        return {
            posSaleTypeId: null,
            arrTipoDocumento: [
                { id: 1, nombre: 'Boleta Electrónica' },
                { id: 2, nombre: 'Factura Electrónica' },
                { id: 3, nombre: 'Venta Empleado' },
            ],
            loading: false,
            numeroFolio: null,
            validate: false,
            infoSale: null,
            showModal: true,
            creditNoteNumber: '',
            comment: '',
            tbkSearch: false,
            flag_cash_return: false,
            see_flag_cash_return: false,
            searching: false,
            suggests: [],
            supervisor: null,
            flagWithTransbankCreditCancellation: false,
        }
    },
    computed: {
        ...mapState('SessionModule', ['isTransbankIntegrated']),
        canFlagWithTransbankCreditCancellation() {
            return this.isTransbankIntegrated
        },
        integrationCountersAreEnabled() {
            return JSON.parse(process.env.VUE_APP_ENABLE_INTEGRATION_COUNTERS)
        },
        rules() {
            let ss = this
            return {
                folioValido(value) {
                    if (!isNaN(value) && value != '') {
                        ss.folioValido = true
                        return true
                    } else {
                        ss.folioValido = false
                        return 'campo debe ser numero'
                    }
                },
            }
        },
        realFolio() {
            return this.tbkSearch === true
                ? 'T' + this.numeroFolio
                : this.numeroFolio
        },
        // ...mapGetters('AuthModule', {
        //     userName: 'userName',
        // }),
        ...mapState('AuthModule', {
            user: 'user',
        }),
        ...mapState('UniqueKeyModule', {
            uniqueKey: 'uniqueKey',
        }),

        ...mapState('SessionModule', ['companyData']),

        ...mapGetters('AuthModule', [
            'userName',
            'branchOfficeID',
            'cashDeskID',
            'branchOfficeName',
            'branchOfficeAddress',
        ]),
    },
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
        }),
        ...mapActions('UniqueKeyModule', {
            authorize: 'authorize',
            setPermission: 'setPermission',
            setUniqueKey: 'setUniqueKey',
        }),
        ...mapActions('CashDeskModule', {
            printVoucher: 'printVoucher',
        }),
        auth: async function() {
            let response = await this.authorize()
            if (response.is_authorized) {
                const fullName = ({ names, last_name1 }) =>
                    `${names} ${last_name1}`
                let supervisor = {
                    name: fullName(response.user),
                    id: response.user.id,
                }
                this.supervisor = supervisor
                this.showList = true
                this.$nextTick(() => this.$refs.selectDocType.focus())
            } else {
                this.$router.push('/')
            }
        },
        cancelEmployeeSale() {
            new PosEmployeeSale({ id: this.numeroFolio })
                .delete()
                .then(() => {
                    let successMsg = this.fillSnack(
                        'success',
                        'Venta Anulada',
                        'La venta empleado ha sido analuada exitosamente',
                        false
                    )
                    this.initSnackbar(successMsg)
                    this.$router.push('/')
                })
                .catch(e => {
                    let snackError = this.fillSnack(
                        'error',
                        'Error',
                        e &&
                            e.response &&
                            e.response.data &&
                            e.response.data.message
                            ? e.response.data.message
                            : 'Ha ocurrido un error'
                    )
                    this.initSnackbar(snackError)
                })
        },
        searchSale: function() {
            //TODO: add validate
            if (this.posSaleTypeId === 3) {
                new PosEmployeeSale()
                    .find(this.numeroFolio)
                    .then(response => {
                        this.infoSale = {
                            number: response.id,
                            emissionDate:
                                response.close_sale_datetime ||
                                response.created_at,
                            type: 'VENTA EMPLEADO',
                            total: response.ticket_total,
                        }
                    })
                    .catch(console.log)
                return
            }
            let pos_sale_type = null
            pos_sale_type = this.posSaleTypeId === 1 ? 1 : 2
            getNumberTicket(this.realFolio, pos_sale_type).then(r => {
                if (this.posSaleTypeId === 1) {
                    this.creditNoteNumber = r.counter
                }
            })
            this.getDTE()
        },
        getDTE: async function() {
            let snackInfo = this.fillSnack(
                'info',
                'Buscando Dte',
                'espere un momento...',
                true
            )
            this.initSnackbar(snackInfo)

            this.flag_cash_return = false
            this.see_flag_cash_return = true

            let response = await creditNoteService.getDTE(
                this.realFolio,
                this.posSaleTypeId
            )

            if (response.status == 200) {
                this.resetSnackbarState()
                //objectToFrontEndFormat(response.data, dteSaleFormat)
                this.infoSale = objectToFrontEndFormat(
                    response.data,
                    dteSaleFormat
                )

                //
                /*PosSaleCustomerReceivablePaymentModel
                    .find()
                    .then()*/

                /*//*
                const payments = this.infoSale.payments
                const paymentsLength  = this.infoSale.payments.length
                const hasMany = this.infoSale.payments.length > 1

                //
                let res = true
                let promises = []

                //
                payments.forEach(payment => {

                    //
                    const isDebit   = payment.pos_sale_payment_type_id === 2
                    const isCredit  = payment.pos_sale_payment_type_id === 5

                    //
                    if(payment.pos_customer_receivable_payment_id) {
                        promises.push(
                            PosCustomerReceivablePaymentModel
                                .append('transformed_payments')
                                .find(payment.pos_customer_receivable_payment_id)
                        )
                    } else {
                        res = res && isDebit || ( isCredit && hasMany )
                    }
                })

                //
                if (promises.length>0) {
                    Promise
                        .all(promises)
                        .then(receivables => {
                            res = receivables.reduce((res_r, rec) => {
                                return res_r && rec.transformed_payments.reduce((res_p, pay) => {
                                    return res_p && pay.pivot.pos_sale_payment_type_id === 2
                                }, true)
                            }, res)

                            this.see_flag_cash_return = res
                        })
                } else {
                    this.see_flag_cash_return = res
                }

                console.log({ res: this.see_flag_cash_return })

                //
                //this.see_flag_cash_return = res//payments.reduce(this.reduceCashReturn(paymentsLength), true)*/

                /*PosSaleModel
                    .include('pos_sale_pos_payment_types.pos_sale_payment_type')
                    .where('number', this.infoSale.id)
                    .get()
                    .then(sales => {
                        this.see_flag_cash_return = sales
                            .data
                            .reduce((r, i) => [ ...r, ...i.pos_sale_pos_payment_types ], [])
                            .reduce((r, i) => i.pos_sale_payment_type_id === 2, false)
                    })*/
            } else {
                let snackError = this.fillSnack(
                    'error',
                    'Error',
                    'Folio No encontrado'
                )
                this.initSnackbar(snackError)
            }
            console.log(response, 'here in get dte')
        },
        getDate() {
            // DESPUÉS MOVER ESTO A UN MIXIN O ÚTILS
            let date = new Date()

            let year = date.getFullYear()

            let month = date.getMonth() + 1
            if (month < 10) {
                month = `0${month}`
            } else {
                month = `${month}`
            }

            let day = date.getDate()
            if (day < 10) {
                day = `0${day}`
            } else {
                day = `${day}`
            }

            return `${day}/${month}/${year}`
        },

        getTime() {
            // DESPUÉS MOVER ESTO A UN MIXIN O ÚTILS
            let date = new Date()

            let hours = date.getHours()
            if (hours < 10) {
                hours = `0${hours}`
            } else {
                hours = `${hours}`
            }

            let minutes = date.getMinutes()
            if (minutes < 10) {
                minutes = `0${minutes}`
            } else {
                minutes = `${minutes}`
            }

            let seconds = date.getSeconds()
            if (seconds < 10) {
                seconds = `0${seconds}`
            } else {
                seconds = `${seconds}`
            }
            return `${hours}:${minutes}:${seconds}`
        },
        searchSuggest() {
            this.searching = true
            if (this.posSaleTypeId === 1) {
                SaleTicketModel.where('number', this.numeroFolio)
                    .get()
                    .then(this.setSuggest)
            } else {
                SaleInvoiceModel.where('number', this.numeroFolio)
                    .get()
                    .then(this.setSuggest)
            }
        },
        setSuggest(res) {
            this.suggests = res.data.map(saleTicket => saleTicket.number)
            this.searching = false
        },
        setNumeroFolio(folio) {
            this.tbkSearch = folio.includes('T')
            this.numeroFolio = folio.split('T').join('')
            this.searchSale()
        },
        sendNotaCredito: async function() {
            if (this.infoSale.type && this.infoSale.type === 'VENTA EMPLEADO') {
                this.cancelEmployeeSale()
                return
            }
            if (!this.$refs.form2.validate()) return
            this.loading = true
            let isTicket = this.posSaleTypeId == 1 ? true : false
            this.initSnackbar(
                this.fillSnack(
                    'info',
                    'Generando Nota de Crédito',
                    'espere un momento',
                    true
                )
            )
            let response = null
            try {
                response = await creditNoteService.generateCreditNote(
                    this.realFolio,
                    isTicket,
                    this.comment,
                    this.creditNoteNumber,
                    this.uniqueKey,
                    this.flag_cash_return,
                    this.flagWithTransbankCreditCancellation,
                )
            } catch (e) {
                this.resetSnackbarState()
                this.loading = false
                this.initSnackbar(
                    this.fillSnack(
                        'error',
                        'Error',
                        e &&
                            e.response &&
                            e.response.data &&
                            e.response.data.error
                            ? e.response.data.error
                            : e &&
                              e.response &&
                              e.response.data &&
                              e.response.data.message
                            ? e.response.data.message
                            : e || 'Ha ocurrido un error'
                    )
                )
                return
            }
            //TODO:cambiar
            console.log(response, 'responseee despues de generar en bakcend')
            if (response.status == 'success') {
                this.resetSnackbarState()
                let successMsg = this.fillSnack(
                    'info',
                    'Imprimiendo Nota de Crédito',
                    'espere un momento',
                    true
                )
                this.initSnackbar(successMsg)

                //
                if (this.flag_cash_return) {
                    this.$store.dispatch('CashMovementModule/printReceipRaw', {
                        idMovCaja: response.pos_cash_movement.id,
                        amount: response.pos_cash_movement.amount,
                        comment: response.pos_cash_movement.observation,
                        supervisor: this.supervisor,
                    })
                }

                //FIXME: Integration only
                if (response.url_file_dte) {
                    this.printVoucher(response.url_file_dte)
                    this.resetSnackbarState()
                    this.validate = false
                    this.$router.push('/')
                } else if (
                    response &&
                    response.sl_sale_credit_note &&
                    response.sl_sale_credit_note.id
                ) {
                    if (
                        this.infoSale.dteTypeTicket &&
                        response.sl_sale_credit_note
                    ) {
                        new SlSaleCreditNote().ticketHtmlPrintByNumber(
                            response.sl_sale_credit_note.number,
                            this.companyData,
                            {
                                officeID: this.branchOfficeID,
                                officeName:
                                    this.branchOfficeName +
                                    ' - ' +
                                    this.branchOfficeAddress,
                                officeCashDeskId: this.cashDeskID,
                            }
                        )
                        this.loading = false
                        this.resetSnackbarState()
                        this.validate = false
                        this.$router.push('/')
                    } else {
                        new SlSaleCreditNote({
                            ...response.sl_sale_credit_note,
                        })
                            .downloadPdf(response.sl_sale_credit_note)
                            .then(() =>
                                this.initSnackbar(
                                    this.fillSnack(
                                        'success',
                                        'Éxito',
                                        'Nota de Crédito generada exitosamente'
                                    )
                                )
                            )
                            .catch(e =>
                                this.initSnackbar(
                                    this.fillSnack(
                                        'error',
                                        'Error',
                                        e &&
                                            e.response &&
                                            e.response.data &&
                                            e.response.data.error
                                            ? e.response.data.error
                                            : e &&
                                              e.response &&
                                              e.response.data &&
                                              e.response.data.message
                                            ? e.response.data.message
                                            : e || 'Ha ocurrido un error'
                                    )
                                )
                            )
                            .finally(() => {
                                this.loading = false
                                this.resetSnackbarState()
                                this.validate = false
                                this.$router.push('/')
                            })
                    }
                }

                /*

                let win = window.open('creditNote.html')
                win.window.eSignatureURL = 'nada'
                win.window.title = null
                //win.window.subtitle = 'BOLETA N°123' // después hacer que reciba n° de boleta como parámetro
                win.window.barcode = '123456789012'
                win.window.RUT = '98.765.432-1'
                win.window.creditNoteNum = response.dte.number //be
                win.window.activities =
                    'VENTA AL POR MAYOR DE OTROS PRODUCTOS N.C.P'
                win.window.address = 'VICENTE ZORRILLA 835, LA SERENA'
                win.window.phone = ''
                win.window.seller = this.userName
                win.window.date = this.getDate()
                win.window.time = this.getTime()
                win.window.preventPrint = localStorage.getItem('_prevent_print')
                win.window.closeTimeout = process.env.VUE_APP_PRINTER_TIMEOUT

                //win.window.total = '2000' //infosale
                win.window.amountPaid = '2222' //infoSale
                win.window.change = 33 //infosale
                win.window.discount = 10 //infosale

                // determinando si es boleta o factura
                win.window.posSaleType = this.posSaleTypeId
                win.window.creditNote = 'NOTA DE CREDITO'
                win.window.netTotal = this.infoSale.netTotal
                win.window.iva = this.infoSale.iva
                win.window.total = this.infoSale.total
                win.window.annulNumber = this.numeroFolio
                win.window.dateCreatedAnnul = this.infoSale.created_at

                //Info Sucursal
                win.window.officeID = this.$store.getters[
                    'AuthModule/branchOfficeID'
                ]
                win.window.officeName = this.$store.getters[
                    'AuthModule/branchOfficeName'
                ]
                win.window.cashDesk = this.$store.getters[
                    'AuthModule/cashDeskID'
                ]

                if (this.supervisor) {
                    win.window.supervisorName = this.supervisor.name // después recibir de algún otro store
                    win.window.supervisorID = this.supervisor.id // después recibir de algún otro store
                }

                // n° folio

                // Después los items debo cargarlos de state.saleDetail
                //win.window.items = [{"id":1,"wh_item_id":1,"wh_pack_id":null,"wh_packing_id":null,"wh_promo_id":null,"wh_subfamily_id":71,"upc_code":"1405037584100","internal_code":"53677204","name":"Bebida Coca Cola Retornable 2 LT","alias_name":"Consequatur nemo accusantium animi.","description":"Sapiente ex quod aliquid iusto deleniti sed sunt vel quo quis.","warranty_days":730,"is_repackaged":true,"is_tax_free":false,"is_salable":true,"is_consumable":true,"is_seasonal":false,"flag_delete":false,"created_at":"2019-01-31 10:07:08","updated_at":"2019-01-31 10:07:08","sale_prices":[{"sale_price":100,"branch_office_id":1,"branch_office_address":"La Serena, Cienfuegos #301"}],"stocks":[{"g_branch_office_id":1,"g_branch_office_address":"La Serena, Cienfuegos #301","wh_warehouses":[{"wh_warehouse_id":1,"wh_warehouse_name":"BOD-001","wh_items":[{"wh_item_id":1,"wh_item_name":"Bebida Coca Cola Retornable 2 LT","wh_item_stock":995}],"logical_stock":995}]},{"g_branch_office_id":2,"g_branch_office_address":"Ovalle, Antofagasta #331","wh_warehouses":[{"wh_warehouse_id":2,"wh_warehouse_name":"BOD-002","wh_items":[{"wh_item_id":1,"wh_item_name":"Bebida Coca Cola Retornable 2 LT","wh_item_stock":1000}],"logical_stock":1000}]}],"sale_price":100,"default_warehouse":1,"stock":995,"active_warehouse":1,"quantity":7,"wholesaleDiscounts":[],"lineDiscount":{"percentage_discount":null,"unit_price_discount":null},"availableWholesaleDiscounts":[],"subtotal":700},{"id":2,"wh_item_id":2,"wh_pack_id":null,"wh_packing_id":null,"wh_promo_id":null,"wh_subfamily_id":30,"upc_code":"8853825278381","internal_code":"73568926","name":"Some Product","alias_name":"Dignissimos ut dolore odit.","description":"Quia fugit natus excepturi amet perspiciatis dignissimos et quas.","warranty_days":365,"is_repackaged":false,"is_tax_free":false,"is_salable":true,"is_consumable":true,"is_seasonal":false,"flag_delete":false,"created_at":"2019-01-31 10:07:08","updated_at":"2019-01-31 10:07:08","sale_prices":[{"sale_price":200,"branch_office_id":1,"branch_office_address":"La Serena, Cienfuegos #301"}],"stocks":[{"g_branch_office_id":1,"g_branch_office_address":"La Serena, Cienfuegos #301","wh_warehouses":[{"wh_warehouse_id":1,"wh_warehouse_name":"BOD-001","wh_items":[{"wh_item_id":2,"wh_item_name":"Some Product","wh_item_stock":995}],"logical_stock":995}]},{"g_branch_office_id":2,"g_branch_office_address":"Ovalle, Antofagasta #331","wh_warehouses":[{"wh_warehouse_id":2,"wh_warehouse_name":"BOD-002","wh_items":[{"wh_item_id":2,"wh_item_name":"Some Product","wh_item_stock":1000}],"logical_stock":1000}]}],"sale_price":200,"default_warehouse":1,"stock":995,"active_warehouse":1,"quantity":4,"wholesaleDiscounts":[{"id":9,"wh_product_id":2,"g_branch_office_id":2,"quantity_discount":40,"unit_price_discount":0,"percentage_discount":47,"flag_delete":false,"created_at":"2019-01-31 10:07:07","updated_at":"2019-01-31 10:07:07"}],"lineDiscount":{"percentage_discount":null,"unit_price_discount":null},"availableWholesaleDiscounts":[],"subtotal":800}]
                if (this.posSaleTypeId == 2) {
                    win.window.items = this.infoSale.sl_detail_sale_invoices
                } else {
                    win.window.items = this.infoSale.sl_detail_sale_tickets
                }

                //FIXME: Integration only
                if (response.url_file_dte) {
                    this.printVoucher(response.url_file_dte)
                }
                this.resetSnackbarState()
                this.validate = false
                this.$router.push('/')

                //VOUCHER ONLY CASH RETURN
                /*if(this.flag_cash_return) {
                    this.printVoucher(response.url_file_dte)
                }

                this.infoSale = null
                this.posSaleTypeId = null
                this.resetSnackbarState()
                this.validate = false
                this.$router.push('/')*/
            } else {
                this.resetSnackbarState()
                let errorSnack = this.fillSnack(
                    'error',
                    'Error',
                    response.data.error
                )
                this.initSnackbar(errorSnack)
            }
        },
        typeDte(number) {
            switch (number) {
                case 33:
                    return 'FACTURA ELECTRÓNICA'
                    break

                case 39:
                    return 'BOLETA ELECTRÓNICA'
                    break
            }
        },
        // downloadCreditNote({ id, number }) {
        //     return new Promise((resolve, reject) =>
        //         Axios.get(
        //             process.env.VUE_APP_API_ROUTE +
        //                 '/sl_sale_credit_note/' +
        //                 id +
        //                 '/pdf',
        //             { responseType: 'blob' }
        //         )
        //             .then(response => {
        //                 const linkSource = URL.createObjectURL(response.data)
        //                 const downloadLink = document.createElement('a')
        //                 const fileName = `${number}-NOTA_DE_CREDITO_ELECTRONICA.pdf`
        //                 downloadLink.href = linkSource
        //                 downloadLink.download = fileName
        //                 downloadLink.click()
        //                 resolve()
        //             })
        //             .catch(reject)
        //     )
        // },
    },
    watch: {
        posSaleTypeId(val) {
            console.log(val, 'cambio de tipo')
            this.$nextTick(() => this.$refs.numFolio.focus())
        },
    },
    components: { 'modal-supervisor': ModalSupervisor },
    mixins: [CurrencyUtils, InputValidations],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function() {
        let branchOfficeUserLogged = this.user.hr_employee.g_branch_office_id
        if (this.integrationCountersAreEnabled)
            getIntegrationCreditNoteNumber(branchOfficeUserLogged)
                .then(r => {
                    this.creditNoteNumber = r
                })
                .catch(e => {
                    console.log(e)
                })
    },
    // beforeMount: function(){...},
    // mounted: function(){...},
    mounted: function() {
        this.setPermission(
            this.mixAuthCodePermissions.AUTHORIZE_GENERATE_CREDIT_NOTE
        )
        document.getElementById('supervisor-modal-button').click()
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
